<template>
    <div>
        <div v-for="(slide, i) in slides" :key="i">
            <button @click.prevent="removeSlide(i)">Remove slide</button>
            <button @click.prevent="addSlide(i)">Add slide</button>
            <select :value="slide.attributes.layout&& slide.attributes.layout.value" @change="changeLayout(i, $event.target.value)">
                <option>default</option>
                <option>defaultSide</option>
                <option>titleOnly</option>
                <option>titleAndSubtitle</option>
            </select>
            <single-slide-preview :xml="slide" :style="getStyle(i)" :editable="editable" :slidesChangeSymbol="slidesChangeSymbol"/>
        </div>
        <button @click.prevent="addSlide(-1)">Add slide</button>
    </div>
</template>
<script>
import SingleSlidePreview from "@/components/SingleSlidePreview.vue";

export default {
    name: 'SlidesPreview',
    components: {SingleSlidePreview},
    props: {
        xml: {
            type: Document,
            required: true
        },
        style: {
            type: Object,
            default: () => ({})
        },
        editable: {
            type: Boolean,
            default: false
        },
        slidesChangeSymbol: {
            type: Symbol,
            default: Symbol()
        }
    },
    data() {
        return {}
    },
    methods: {
        addSlide(index) {
            const newSlide = this.xml.createElement('slide');
            const newTitle = this.xml.createElement('title');
            newTitle.textContent = 'New slide';
            newSlide.appendChild(newTitle);
            const newText = this.xml.createElement('text');
            newText.textContent = 'New text';
            newSlide.appendChild(newText);
            this.xml.documentElement.insertBefore(newSlide, this.xml.documentElement.children[index]);
            this.$emit('changeXml', this.xml);
        },
        removeSlide(index){
            this.xml.documentElement.children[index].remove();
            this.$emit('changeXml', this.xml);
        },
        getStyle(i){
            if(i==0){
                return {...this.style, background: this.style.backgroundTitle, color: this.style.colorTitle};
            }else
            {
                return this.style;
            }
        },
        changeLayout(index, value){
            this.xml.documentElement.children[index].setAttribute('layout', value);
            this.$emit('changeXml', this.xml);
        }
    },
    computed: {
        slides() {
            void this.slidesChangeSymbol;
            if (!this.xml) return [];
            return [...this.xml?.querySelectorAll('slide')??[]]
        }
    }
}
</script>
<style>
</style>
